import { AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import CodeTabs from 'components/shared/code-tabs';
import ImagePlaceholder from 'components/shared/image-placeholder';
import Link from 'components/shared/link';

const SectionWithCode = ({ title, description, linkText, linkUrl, items }) => {
  const [codeTabsWrapper, isCodeTabsWrapperInView] = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  return (
    <section className="safe-paddings">
      <div className="container">
        <div className="flex items-center justify-between lg:block">
          <div className="max-w-[484px] xl:max-w-[376px] lg:mx-auto lg:max-w-[584px] md:max-w-none">
            <h2 className="text-4xl font-bold leading-tight">{title}</h2>
            <p className="mt-4">{description}</p>
            {linkUrl && linkText && (
              <Link className="mt-7 lg:mt-6" to={linkUrl} size="sm" theme="black-underline">
                {linkText}
              </Link>
            )}
          </div>
          <div
            className="relative xl:h-[418px] xl:w-[455px] lg:mx-auto lg:mt-8 lg:w-[584px] md:w-full"
            ref={codeTabsWrapper}
          >
            <ImagePlaceholder height={488} width={640} />
            <AnimatePresence>
              {isCodeTabsWrapperInView && (
                <CodeTabs
                  className="absolute left-0 top-0 h-full w-full"
                  items={items}
                  animate={isCodeTabsWrapperInView}
                  withAnimation
                />
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};

SectionWithCode.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      language: PropTypes.oneOf([
        'csharp',
        'dart',
        'java',
        'javascript',
        'kotlin',
        'objectivec',
        'swift',
      ]).isRequired,
    })
  ).isRequired,
};

SectionWithCode.defaultProps = {
  linkText: null,
  linkUrl: null,
};

export default SectionWithCode;
